
import styles from './MobileMenu.module.scss'
import Toggle from '../../components/toggle'
import Link from 'next/link'
import SocialIcons from '../../components/social-icons/SocialIcons'
import Button from '../../components/Button'
import { navItems } from './NavItems'
import Image from 'next/image'

import Xmark from '../../components/icons/xmark.svg'
import DollarCircle from '../../components/icons/dollar-circle.svg'
import Cake from '../../components/icons/cake.svg'
import MoneyBill from '../../components/icons/money-bill.svg'

function Logo({ open }) {

	return (
		<Link href='/' aria-label="home" className={styles.logo} tabIndex={open ? 0 : -1}>
			<Image
				src="/purple-lotus-logo-black-text.svg"
				alt="mobile menu logo"
				width={160}
				height={45}
			/>
		</Link>
	)
}

export default function MobileMenu(props) {
	const handleClick = props.handleClick
	const open = props.open

	return (
		<div className={styles.mobileMenu}>
			<div className={styles.header}>
				{open && <Logo open={open} />}
				<Button type="button" className="icon xmark" ariaLabel="close mobile menu" onClick={() => handleClick()} tabIndex={open ? 0 : -1}>
					<Xmark />
				</Button>
			</div>
			<div className={styles.list}>

				{navItems.navItems.map((item) => {
					if (item.links) {
						return (
							<NavToggle
								key={item.title}
								title={item.title}
								link={item.link}
								handleClick={handleClick}
								links={item.links}
								open={open}
							/>
						);
					}
					else if (item.title !== 'home') {
						return (
							<NavItem
								key={item.title}
								title={item.title}
								link={item.link}
								handleClick={handleClick}
								open={open}
							/>
						);
					}
				})}

				<div className={styles.login}>
						<div className={styles.title}>Purple Lotus <span>Rewards</span></div>
						<div className={styles.subtitle}>Join our rewards program to start earning points and execlusive discounts. <Link href="/rewards" className="link" onClick={() => handleClick()}>Learn More</Link></div>
					<div className={styles.rewards}>
						<div>
							<DollarCircle />
							<span>Points Per $</span>
						</div>
						<div>
							<MoneyBill />
							<span>$10 Reward</span>
						</div>
						<div>
							<Cake />
							<span>Birthday Gift</span>
						</div>
					</div>
					<Button type="link" href="/login" className="primary" onClick={() => handleClick()}>Login</Button>
					<Link href="/login" onClick={() => handleClick()}>Sign up</Link>
				</div>

				<div className={styles.socials}>
					<SocialIcons tabIndex={open ? 0 : -1} />
				</div>
			</div>
		</div>
	)

}

function NavItem(props) {
	const { link, title, handleClick, open } = props
	return (
		<Link
			href={link}
			className={styles.item}
			onClick={() => handleClick()}
			tabIndex={open ? 0 : -1}
		>
			{title}
		</Link>
	)
}

function NavToggle(props) {
	const { title, handleClick, links, open } = props
	return (
		<Toggle
			key={title}
			title={title}
			class={styles.toggle}
		>
			{links.map((item) => (
				<Link key={item.title} href={item.link} onClick={() => handleClick()} tabIndex={open ? 0 : -1}>
					{item.title}
				</Link>
			))}
		</Toggle>
	)
}